import { StorageService } from './StorageService';

export class EncodedStorageService extends StorageService {
    constructor() {
        super(true);
    }
}